export default "<div id=\"left-border\"></div>\n<div id=\"right-border\"></div>\n<div id=\"top-border\"></div>\n<div id=\"bottom-border\"></div>\n";